import React from 'react';
import { useTranslation } from 'utils/i18n';

interface Facet {
  name: string;
}

interface Props {
  roomFacets: Array<Facet>;
  propertyFacets: Array<Facet>;
  roomEquipment: Array<Facet>;
  floor: string;
  notes: string;
}

const FacetsEquipment: React.FC<Props> = ({
  roomFacets = [],
  propertyFacets = [],
  roomEquipment = [],
  floor,
  notes,
}) => {
  const { t } = useTranslation('common');
  const roomFacetsNames = roomFacets.map(facet => facet.name);

  const filteredPropertyFacets = propertyFacets.filter(
    facet => !roomFacetsNames.includes(facet.name)
  );

  const renderRoomFacets = () => {
    if (floor || notes || roomFacets.length > 0) {
      return (
        <div className="facets-equipment__item">
          <h3>{t('facets_equipment.room_features')}</h3>
          <ul>
            {floor && <li>{floor}</li>}
            {notes && notes !== floor && <li>{notes}</li>}
            {roomFacets.map(facet => (
              <li key={facet.name}>{facet.name}</li>
            ))}
          </ul>
        </div>
      );
    }
    return null;
  };

  const renderPropertyFacets = () => {
    if (propertyFacets.length > 0) {
      return (
        <div className="facets-equipment__item">
          <h3>{t('facets_equipment.property_features')}</h3>
          <ul>
            {filteredPropertyFacets.map(facet => (
              <li key={facet.name}>{facet.name}</li>
            ))}
          </ul>
        </div>
      );
    }
    return null;
  };

  const renderRoomEquipment = () => {
    if (roomEquipment.length > 0) {
      return (
        <div className="facets-equipment__item">
          <h3>{t('facets_equipment.room_assets')}</h3>
          <ul>
            {roomEquipment.map(equipment => (
              <li key={equipment.name}>{equipment.name}</li>
            ))}
          </ul>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="facets-equipment">
      {renderRoomFacets()}
      {renderPropertyFacets()}
      {renderRoomEquipment()}
    </div>
  );
};

export default FacetsEquipment;
